import React from 'react';
import './dram.css';
import {Controlled as CodeMirrorComponent} from 'react-codemirror2';
import { Icon, Button, NumericInput } from '@blueprintjs/core';
import StringSelect from '../stringselect';
import ThemeContext from '../themecontext';
import SolutionPanel from '../solutionpanel';
import _ from 'lodash';

export default class DRAM extends React.Component {

    constructor(props) {
        super(props);
        this.state = {  
                        speed: 1600,
                        technology: "DDR3",
                        TCAS: 8,
                        TRCD: 2,
                        TRP: 2,
                        references: "",
                        scheduleFCFS: [],
                        scheduleFRFCFS: [],
                        error: "",
                        numOfAddresses: 4,
                        addresses: "",
                        initialRow: -1,
                        pageClosing: true
                    };
        this.checkParamValidity = this.checkParamValidity.bind(this);
        this.generateReferences = this.generateReferences.bind(this);
        this.generateParams = this.generateParams.bind(this);
        this.generateSchedule = this.generateSchedule.bind(this);
        this.pattern = /^\s*(0|[1-9]\d*).\s*sor\s*,\s*(0|[1-9]\d*).\s*oszlop\s*$/i;
    }

    componentDidMount() {
        this.generateParams();
        this.generateReferences();
    }

    getValidReferences() {
        const refs = [];
        this.state.addresses.split("\n").forEach(line => {
            if (this.pattern.test(line)) {
                const groups = line.match(this.pattern);
                if (groups.length >= 3)
                    refs.push([parseInt(groups[1]), parseInt(groups[2])]);
            }
        });
        return refs;
    }

    generateParams() {
        const options = {
            DDR1: [
                ["DDR1", 200, 2, 3],
                ["DDR1", 266, 2, 3],
                ["DDR1", 333, 2, 3],
                ["DDR1", 400, 2, 3]
            ],
            DDR2: [
                ["DDR2", 400, 3, 4],
                ["DDR2", 533, 3, 4],
                ["DDR2", 666, 4, 5],
                ["DDR2", 800, 4, 6],
                ["DDR2", 1066, 6, 7]
            ],
            DDR3: [
                ["DDR3", 800, 5, 6],
                ["DDR3", 1066, 6, 8],
                ["DDR3", 1333, 7, 10],
                ["DDR3", 1600, 8, 11],
                ["DDR3", 1866, 10, 13],
                ["DDR3", 2133, 11, 14]
            ],
            DDR4: [
                ["DDR4", 1600, 10, 12],
                ["DDR4", 1866, 12, 14],
                ["DDR4", 2133, 14, 16],
                ["DDR4", 2400, 15, 18],
                ["DDR4", 2666, 17, 20],
                ["DDR4", 2933, 19, 22],
                ["DDR4", 3200, 20, 24]
            ]
        };

        const technology = "DDR" + _.sample([1, 2, 3, 4]);
        const option = _.sample(options[technology]);
        const TCAS = option[2] + Math.round(Math.random()*(option[3]-option[2]));
        const TRCD = TCAS + Math.round(Math.random()*2);
        this.setState({technology, speed: option[1], TCAS, TRCD, TRP: TRCD});
    }

    generateReferences() {        
        const spread = 3;
        const indices = _.range(0, this.state.numOfAddresses);
        const rowRefs = indices.map(x => Math.floor(Math.random() * this.state.numOfAddresses * spread));
        const toRepeat = _.sample(_.slice(indices, 0, indices.length-2));
        const target = _.sample(_.slice(indices, toRepeat+2, indices.length));
        rowRefs[target] = rowRefs[toRepeat];
        rowRefs[target-1] = rowRefs[toRepeat] + Math.floor(Math.random() * 2) + 1;

        let initial = -1;
        if (Math.random() < 0.5) {
            initial = Math.floor(Math.random() * this.state.numOfAddresses * spread);
            const target = _.sample(_.slice(indices, 1, indices.length));
            rowRefs[target] = initial;
            rowRefs[target-1] = initial + Math.floor(Math.random() * 2) + 1;
        }
        const colRefs = _.shuffle(indices).map(val => val*8);

        this.setState({addresses: rowRefs.map((row, ix) => 
                ("" + row + ". sor, " + colRefs[ix] + ". oszlop")
            ).join("\n"), initialRow: initial, pageClosing: Math.random() < 0.5}, 
            () => this.generateSchedule());        
    }

    generateSchedule() {

        let refs = this.getValidReferences();
        const scheduleFCFS = [];
        if (refs.length > 0) {
            let prevRow = this.state.initialRow;
            for(let ix = 0; ix < refs.length; ix++) {
                if (refs[ix][0] !== prevRow) {
                    if (prevRow >= 0)
                        scheduleFCFS.push(["Precharge", ""]);
                    scheduleFCFS.push(["Activate", refs[ix][0]]);
                }
                scheduleFCFS.push(["Read", refs[ix][1]]);                    
                prevRow = refs[ix][0];
            }
            if (this.state.pageClosing)
                scheduleFCFS.push(["Precharge", ""]);
        }

        const scheduleFRFCFS = [];
        if (refs.length > 0) {
            let prevRow = this.state.initialRow;
            for(let ix = 0; ix < refs.length; ix++) {
                // find faster oportunity
                let jx = ix;
                while (jx < refs.length && refs[jx][0] !== prevRow)
                    jx++;
                if (jx < refs.length) {
                    const toMove = refs[jx];
                    refs.splice(jx, 1);
                    refs.splice(ix, 0, toMove);
                }
                if (refs[ix][0] !== prevRow) {
                    if (prevRow >= 0)
                        scheduleFRFCFS.push(["Precharge", ""]);
                    scheduleFRFCFS.push(["Activate", refs[ix][0]]);
                }
                scheduleFRFCFS.push(["Read", refs[ix][1]]);                    
                prevRow = refs[ix][0];
            }
            if (this.state.pageClosing)
                scheduleFRFCFS.push(["Precharge", ""]);
        }

        this.setState({scheduleFCFS, scheduleFRFCFS});
    }

    checkParamValidity() {
        let error = "";
        const problems = [];
        this.state.addresses.split("\n").forEach((line, ix) => {
            if (this.pattern.test(line) === false) 
                problems.push(ix+1);
        });
        if (problems.length > 0)
            error = 'Nem megfelelő kérés formátum! Helyes alak: "x. sor, y. oszlop". Az érintett sorok sorszáma: ' + problems.join(", ");
        this.setState({error});
    }

    renderSchedule(title, schedule) {
        return <div className="demo-table-container">
            <h3>{title}</h3>
            <table className="dram-schedule-table">
                <tbody>
                    {schedule.map((row, ix) => <tr key={ix}><td>{row[0]}</td><td>{row[1]}</td></tr>)}
                </tbody>
            </table>
        </div>;
    }

    static contextType = ThemeContext;

    render() {
        let clkMult = parseInt(this.state.technology[3]);
        if (clkMult === 4)
            clkMult = 3;
        const externalClk = this.state.speed / 2;
        const internalClk = externalClk / Math.pow(2, clkMult-1);
        const burstSpeed = this.state.speed * 64 / 8;
        const cycle = 1000 / externalClk;
        const latency = cycle * this.state.TCAS;        

        let delayToStartText = [];
        let delayToStart = 0;
        for(let ix=0; ix<this.state.scheduleFCFS.length && this.state.scheduleFCFS[ix][0]!=="Read"; ix++) {
            if (this.state.scheduleFCFS[ix][0] === "Activate") {
                delayToStartText.push(<span key={ix}>T<sub>RCD</sub>+</span>);
                delayToStart += this.state.TRCD;
            }
            else if (this.state.scheduleFCFS[ix][0] === "Precharge") {
                delayToStartText.push(<span key={ix}>T<sub>RP</sub>+</span>);
                delayToStart += this.state.TRP;
            }
        }
        delayToStartText.push(<span key={this.state.scheduleFCFS.length}>T<sub>CAS</sub></span>);
        delayToStart += this.state.TCAS;
        const delayToStartTime = delayToStart * cycle;

        return (
            <>
                <div className="title-area">
                    <h1>Memóriatechnológiák</h1>
                    <h2>Parancsütemezés, átviteli sebesség, időzítések</h2>
                </div>
                <div className="demo-emph-row">
                    <div className="dram-param-panel">
                        <h3>Paraméterek:</h3>
                        Egy számı́tógép rendszermemóriája egycsatornás, 64 bites adategységekkel rendelkező &nbsp;
                            <StringSelect
                                items={["DDR1", "DDR2", "DDR3", "DDR4"]}
                                initial={this.state.technology}
                                onChange={val => this.setState({technology: val})}
                            />  &nbsp; –  &nbsp; <div className="dram-param-speed"><NumericInput 
                                    fill="true"
                                    value={this.state.speed}
                                    onValueChange={val => this.setState({speed: val})}
                                    min={200}
                                    max={6400}
                            /></div>  &nbsp; technológiára épül, a burst méret 8 adategységnyire van beállı́tva.
                            <p className="dram-timing-title">Az időzítések az alábbiak:</p>
                        <div className="dram-param-grid">
                            <div className="dram-param-label">T<sub>CAS</sub> = </div>
                            <div className="dram-param-row">
                                <NumericInput 
                                    className="dram-param-numeric"
                                    fill="true"
                                    value={this.state.TCAS}
                                    onValueChange={val => this.setState({TCAS: val})}
                                    min={2}
                                    max={64}
                                /> (a nyitott sor egy oszlopának a kiolvasásához szükséges külső órajelek száma)
                            </div>
                            <div className="dram-param-label">T<sub>RCD</sub> = </div>
                            <div className="dram-param-row">
                                <NumericInput 
                                    className="dram-param-numeric"
                                    fill="true"
                                    value={this.state.TRCD}
                                    onValueChange={val => this.setState({TRCD: val})}
                                    min={2}
                                    max={128}
                                /> (a sormegnyitási késleltetés, külső órajelben mérve)
                            </div>                            
                            <div className="dram-param-label">T<sub>RP</sub> = </div>
                            <div className="dram-param-row">
                                <NumericInput 
                                    className="dram-param-numeric"
                                    fill="true"
                                    value={this.state.TRP}
                                    onValueChange={val => this.setState({TRP: val})}
                                    min={2}
                                    max={128}
                                /> (a PRECHARGE parancs végrehajtásához szükséges külső órajelek száma)
                            </div>
                        </div>
                        <Button 
                            icon="refresh"
                            text="Random generálás"
                            className="dram-generate-button"
                            onClick={this.generateParams} 
                        />

                        <p>A memóriavezérlőhöz beérkező (1 burst-nyi) olvasási kérések az alábbi sor, oszlop 
                            koordinátákra vonatkoznak:</p>
                        <div className="dram-sequence-params">
                            <div className="dram-sequence-area">
                                <div className="dram-sequence-editor">
                                    <CodeMirrorComponent
                                        value={this.state.addresses}
                                        options={{
                                            theme: this.context === "dark" ? "material" : "default",
                                            lineNumbers: true}}
                                        onBeforeChange={(editor, data, value) => {
                                            this.setState({addresses: value}, () => {
                                                this.checkParamValidity();
                                                this.generateSchedule();
                                            });
                                        }}                                        
                                    />                           
                                </div>   
                                <div className="dram-sequence-bottom-panel">
                                        <Button 
                                            icon="refresh" 
                                            text="Random"
                                            className="dram-refresh-sequence"
                                            onClick={() => this.generateReferences()} 
                                        />
                                        <NumericInput 
                                            className="dram-sequence-num"
                                            fill="true"
                                            value={this.state.numOfAddresses}
                                            onValueChange={val => this.setState({numOfAddresses: val})}
                                            min={2}
                                            max={8}
                                        /> 
                                        <div>kérés</div>
                                </div>
                            </div>
                            {this.state.error !=="" && <div className="code-error-area">
                                <Icon icon="error"/>&nbsp;{this.state.error}
                            </div>}
                        </div> 
                        <p>
                            {this.state.initialRow < 0 && "Kezdetben a memória alap állapotban van (a legutóbbi parancs sor lezárás volt)."}
                            {this.state.initialRow >= 0 && `Kezdetben a ${this.state.initialRow}. sor nyitott állapotban van.`}
                            {` Az utolsó parancs után a memóriavezérlő ${this.state.pageClosing === true ? "" : "ne"} zárja le a nyitott sort!`}
                        </p>
                    </div>
                </div>
                <div>
                    <h3>1. Feladat</h3>
                    <p> A memóriavezérlőhöz beérkező 64 bájtos (tehát 1 burst-nyi) olvasási kérések az alábbi 
                        sor, oszlop koordinátákra vonatkoznak:
                    </p>
                    <p>
                        Adja meg a fenti kérésekhez tartozó, memóriavezérlő által kiadott DRAM parancsokat 
                        sorrendhelyesen), feltéve, hogy a kérések egyazon bankra és egyazon rank-re vonatkoznak, és feltéve, 
                        hogy bankonként csak egyetlen sor lehet nyitva.
                    </p>
                </div>
                <div>
                    <SolutionPanel title="Megoldás mutatása">
                        <div className="demo-emph-row">
                            <div className="dram-sequence-params">
                                {this.renderSchedule("FCFS ütemezéssel:", this.state.scheduleFCFS)}
                                {this.renderSchedule("FR-FCFS ütemezéssel:", this.state.scheduleFRFCFS)}
                            </div>
                        </div>
                    </SolutionPanel>
                </div>
                <div>
                    <h3>2. Feladat</h3>
                    <p> Adjon választ az alábbi, időzítéssel és sebességgel kapcsolatos kérdésekre!</p>
                    <ol type="a">
                        <li>Adja meg a memória belső órajel-frekvenciáját!</li>
                        <li>Adja meg a memória külső órajel-frekvenciáját!</li>
                        <li>Adja meg az adatátviteli sebességet a burst átvitele alatt!</li>
                        <li>Adja meg a memória késleltetését (a parancskiadástól az adat megjelenéséig eltelt idő, optimális esetben)!</li>
                        <li>Hányadik (külső) órajelben, és mennyi idő múlva jelenik meg az FCFS ütemezés szerinti első olvasási kérésre adott első adategység az adatbuszon?</li>
                        <li>Hányadik (külső) órajelben, és mennyi idő múlva jelenik meg az FCFS ütemezés szerinti első olvasási kérésre adott utolsó adategység az adatbuszon?</li>
                    </ol>
                </div>
                <div>
                    <SolutionPanel title="Megoldás mutatása"> 
                        <div className="demo-emph-row">
                            <ol type="a">
                                <li>
                                    DDR memóriáknál a külső órajel fel- és lefutó élén is történik adatátvitel, így a külső órajel-frekvencia a DRAM
                                    megnevezésében szereplő adatátviteli frekvencia felével lesz egyenlő, ami <span className="demo-solution-value">f<sub>bus</sub> = {externalClk} MHz</span>.
                                </li>
                                <li>
                                    A {this.state.technology} memóriáknál a külső és belső órajelfrekvencia közötti szorzó {Math.pow(2, clkMult-1)}, így a belső órajel-frekvencia
                                    <span className="demo-solution-value">f<sub>dram</sub> = {internalClk} MHz</span>.
                                </li>
                                <li>
                                    A külső órajel minden ciklusában kétszer történik adatátvitel, mégpedig 64 bites adategységekkel számolva 8 byte. Ennek megfelelően az
                                    adatátviteli sebesség <span className="demo-solution-value">TP = f<sub>bus</sub>×2×8 = {burstSpeed} MB/s</span>.
                                </li>
                                <li>
                                    Az optimális eset úgy áll elő, hogy a hivatkozott sor épp nyitva van, ekkor a késleltetés megegyezik T<sub>CAS</sub> értékével. Ez az érték azonban
                                    külső órajelciklusban van megadva, nem időben, így ki kell számítanunk a külső órajel ciklusidejét. A ciklusidő ns-ban mérve 1000/f<sub>bus</sub>, ha 
                                    f<sub>bus</sub> MHz-ben adott. Ennek megfelelően a késleltetés <span className="demo-solution-value">t<sub>CAS</sub> = 1000×T<sub>CAS</sub>/f<sub>bus</sub> = {latency.toFixed(1)} ns</span>.
                                </li>
                                <li>
                                    Az FCFS üzemetés szerint az első olvasás idejéig eltelő külső órajelciklusok száma <span className="demo-solution-value">{delayToStartText} = {delayToStart}</span>,
                                    ami időre átváltva <span className="demo-solution-value">1000×{delayToStart}/f<sub>bus</sub> = {delayToStartTime.toFixed(1)} ns</span>.
                                </li>
                                <li>
                                    A teljes burst átvitele a {this.state.technology}-DRAM memóriában {4} (külső) órajelciklust vesz igénybe.
                                    Figyelembe véve az előző feladatban kiszámolt időt az első adat megjelenéséig, valamint azt a tényt, hogy a burst utolsó adata feledik ciklusban, 
                                    azaz lefutó élen megy át, az eredmény <span className="demo-solution-value">{delayToStart+4-0.5} órajelciklus</span>, időben
                                    kifejezve <span className="demo-solution-value">{delayToStartTime.toFixed(1)} ns + (4-0.5)×{cycle.toFixed(1)} ns = 
                                    {(delayToStartTime + cycle * (4-0.5)).toFixed(1)} ns</span>.
                                </li>
                            </ol>
                        </div>
                    </SolutionPanel>
                </div>                
            </>
        );
    }
}